module.exports = __webpack_public_path__ + "static/media/networks.8b9d5fdf.jpg";